import { BrandConfig } from './brandConfig';
import { nlCountryOption } from './countryOptions';

const qualityLodgingsConfig: BrandConfig = {
    contactUrl: 'https://qualitylodgings.com/nl/contact',
    countryOptions: [nlCountryOption],
    brandName: 'Quality Lodgings',
};

export default qualityLodgingsConfig;
